<template>
    <div class="card p-3 h-100">
      <h2 v-if="title" class="mb-4">{{ title }}</h2>
      <rota-form @updated="onFormUpdate($event)" 
                          :skipMountedEmit="true"
                          :charity="charity"
                          :availabilityPeriods="availabilityPeriods"></rota-form>
    </div>
</template>

<script>
  // Imports
  import RotaForm from '../Forms/RotaForm';
  import CharitiesService from '../../services/CharitiesService';
  import days from '../../util/days-of-the-week';
  //
  export default {
    name: 'charity-rota-card',
    components: {
     RotaForm
    },

    props:[
      'charity',
      'title'
    ],

    data() {
      return {
        availabilityPeriods: []
      };
    },

    async created(){
       this.updateActivityPeriods();
    },

    computed:{
        
    },

    methods: {
      /**
       * The rota has been updated send the data to the API
       * @param {object} rotaData The new rotat data;
       */
      onFormUpdate: async function(rotaData){

        for (let index = 0; index < days.length; index++) {
          const day = days[index];
          this.charity['demand' + day] = rotaData.quantities[index];
        }
        try{
          // Store the new Demand data on the charity
          let charityResult = await CharitiesService.update(this.charity.id, this.charity);
          // Store the availability periods in the DB
          let availibilityPeriodsResult = await CharitiesService.postAvailabilityPeriods(this.charity.id, {periods:rotaData.periods});
          // Tell the parent that the charity data has updated
          this.$emit('charityUpdated');
        }catch(error){
          console.log(error);
        }
      },

      /**
       * Update to the latest serve activity perdio data
       */
      async updateActivityPeriods(){
        let result = await CharitiesService.getAvailabilityPeriods(this.charity.id);
        this.availabilityPeriods = result.data;
      }
    },

    watch:{
      charity: function(){
        this.updateActivityPeriods();
      }
    }
  }
</script>